export default { sha: '1d934af94ad13a42c9100f06cad1a5f9677eef6c', buildNumber: 'undefined' }
